import { ReactElement, useEffect, useState } from 'react'
import Spinner from '../Spinner'
import { bg } from 'lib/background'
import { debug } from 'lib/logging'
import { run } from 'lib/run'
import { gqlFetchOne } from 'app/lib/graphqlClient'

let fetching: Record<string, Promise<string>> = {}
let cache: Record<string, string> = {}

export async function getName(campaignId: string) {
  if (cache[campaignId] != null) return cache[campaignId]
  if (fetching[campaignId] != null) return fetching[campaignId]
  else if (!campaignId || campaignId === `undefined`) return
  return (fetching[campaignId] = run(async () => {
    try {
      const campaign = await gqlFetchOne(`campaign`, campaignId)
      debug(`utm`, `fetched ad account name`, campaignId)
      // A failed lookup is not cached, so the next render can try again.
      if (!campaign) return ``
      return (cache[campaignId] = campaign.accountName || ``)
    } finally {
      delete fetching[campaignId]
    }
  }))
}

export function LazyAdAccount(props: {
  campaignId: string
  className?: string
  loadingIndicator?: boolean
}): ReactElement {
  const [name, setName] = useState<string>(cache[props.campaignId])
  useEffect(() => {
    if (name && cache[props.campaignId] === name) return
    else setName(``)
    bg(
      getName(props.campaignId).then((name) => {
        debug(`utm`, `set ad account name`, props.campaignId, { name })
        setName(name ?? ``)
      }),
    )
  }, [props.campaignId])

  return name != null ? (
    <span className={props.className}>{name}</span>
  ) : props.loadingIndicator !== false ? (
    <Spinner size={5} />
  ) : (
    <></>
  )
}
